export default "__VITE_ASSET__CCRIo_7Q__"